<template>
  <div class="rtsp_wrap">
    <el-aside width="200px">
      <el-row class="title">
        <div class="grid-content bg-purple">通道列表</div>
      </el-row>
      <el-row class="search">
        <el-input suffix-icon="el-icon-search" placeholder="请输入"></el-input>
      </el-row>
      <div class="custom-tree-container">
        <div class="block">
          <el-tree
            :data="checkoutTreeData"
            node-key="id"
            @node-click="clickCheckout"
            highlight-current
            :expand-on-click-node="false"
            :default-expanded-keys="[3, 30]"
          >
            <span class="custom-tree-node is-show" slot-scope="{ node }">
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </div>
    </el-aside>
    <div id="video-container">
      <video
        id="video"
        :class="[play == 1 ? 'active_video' : 'normal_video']"
        ref="video"
        controls
        autoplay
        muted
        width="100%"
        height="100%"
        style="object-fit: fill"
      ></video>
      <video
        id="video2"
        :class="[play == 2 ? 'active_video' : 'normal_video']"
        controls
        autoplay
        muted
        width="100%"
        height="100%"
        style="object-fit: fill"
      ></video>
      <video
        id="video3"
        :class="[play == 3 ? 'active_video' : 'normal_video']"
        controls
        autoplay
        muted
        width="100%"
        height="100%"
        style="object-fit: fill"
      ></video>
      <div class="mask" @click="handleClickVideo"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      play: 1,
      webRtcServer: null,
      camera_ip: "192.168.90.189:8000",
      checkoutTreeData: [
        {
          label: "一级 1",
          id: 1,
          children: [
            {
              label: "二级 1-1",
              id: 10,
              children: [
                {
                  label: "三级 1-1-1",
                  id: 101,
                },
              ],
            },
          ],
        },
        {
          label: "一级 2",
          id: 2,
          children: [
            {
              label: "二级 2-1",
              id: 20,
              children: [
                {
                  label: "三级 2-1-1",
                  id: 201,
                },
              ],
            },
            {
              label: "二级 2-2",
              id: 21,
              children: [
                {
                  label: "三级 2-2-1",
                  id: 211,
                },
              ],
            },
          ],
        },
        {
          label: "浙江锦辉",
          id: 3,
          children: [
            {
              label: "锦辉试验机",
              id: 30,
              children: [
                {
                  label: "锦辉试验机_1",
                  id: 301,
                },
                {
                  label: "锦辉试验机_2",
                  id: 302,
                },
                {
                  label: "锦辉试验机_3",
                  id: 303,
                },
                {
                  label: "锦辉试验机_4",
                  id: 304,
                },
              ],
            },
          ],
        },
      ],
    };
  },
  mounted() {
    //video：需要绑定的video控件ID
    //127.0.0.1:8000：启动webrtc-streamer的设备IP和端口，默认8000
    this.webRtcServer = new window.WebRtcStreamer(
      "video",
      location.protocol + "//" + this.camera_ip
    );
    //需要查看的rtsp地址,根据自己的摄像头传入对应的rtsp地址即可。注意：视频编码格式必须是H264的，否则无法正常显示，编码格式可在摄像头的后台更改
    this.webRtcServer.connect(
      "rtsp://114.55.113.142:9090/dss/monitor/param?cameraid=1000185%240%26&substream=1",
      null,
      "rtptransport=tcp",
      null
    );
  },
  methods: {
    clickCheckout() {
      console.log("ppppp");
    },
    /* 视频全屏 */
    handleClickVideo() {
      const elVideo = this.$refs.video;
      if (elVideo.webkitRequestFullScreen) {
        elVideo.webkitRequestFullScreen();
      } else if (elVideo.mozRequestFullScreen) {
        elVideo.mozRequestFullScreen();
      } else if (elVideo.requestFullscreen) {
        elVideo.requestFullscreen();
      }
    },
  },
  //销毁视频流
  beforeDestroy() {
    this.webRtcServer.disconnect();
    this.webRtcServer = null;
  },
};
</script>

<style lang="scss" scoped>
.rtsp_wrap {
  width: calc(100% - 20px);
  height: 100%;
  display: flex;
  margin-left: 20px;
  /deep/ .el-aside {
    margin-right: 0 !important;

    .search {
      margin: 0 10px !important;

      .el-input__inner {
        height: 32px !important;
        line-height: 32px !important;
      }

      .el-input__suffix {
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }
  .custom-tree-container {
    margin-top: 10px;
  }
  .active-video-border {
    border: 2px salmon solid;
  }
  #video-container {
    position: relative;
    flex: 1;
    // width: 100%;
    // height: 100%;
    .active_video {
      display: block;
    }
    .normal_video {
      display: none;
    }
    .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
</style>
